/* eslint-disable @typescript-eslint/no-explicit-any */

import { IStorage } from './definition';

const THREE_MINUTES = 3 * 60 * 1000;

class MemoryStorage implements IStorage {
  private cache: Map<
    string,
    {
      data: any;
      validity: number;
    }
  >;

  constructor() {
    this.cache = new Map();

    this.startCleanupChecker();
  }

  private startCleanupChecker(): void {
    setInterval(() => {
      const entries = Array.from(this.cache.entries());

      entries.forEach(([key, { validity }]) => {
        if (!this.isValid(validity)) this.delete(key);
      });
    }, THREE_MINUTES);
  }

  private isValid(validity: number): boolean {
    return Date.now() < validity;
  }

  get<T = any>(key: string): T | undefined {
    const saved = this.cache.get(key);

    if (saved && this.isValid(saved.validity)) return saved.data;

    this.delete(key);
  }

  set(key: string, data: any, validity?: Date): void {
    this.cache.set(key, { data, validity: Number(validity ?? Number.MAX_SAFE_INTEGER) });
  }

  delete(key: string): void {
    this.cache.delete(key);
  }

  clear(): void {
    this.cache = new Map();
  }
}

export const memoryStorage = new MemoryStorage();
